<template>
<div class="WithdrawalList">
    <div class="bgc box-shadow title">
        <div class="classes blod">{{title}}</div>
    </div>
    <div class="data-total">
        <div class="outbox box-shadow bgc">
            <div class="box">
                <div class="box-detail">
                    <div class="box-title">商家待提现金额</div>
                    <div class="box-data"><span class="data">{{item.settlemoney}}</span>元</div>
                </div>
            </div>
            <el-tooltip content="商家所有活动还未提现成功的金额 " placement="top">
                <div>
                    <i class="tip el-icon-info"></i>
                </div>
            </el-tooltip>
        </div>
        <div class="outbox box-shadow bgc">
            <div class="box">
                <div class="box-detail">
                    <div class="box-title">商家提现中金额</div>
                    <div class="box-data"><span class="data">{{item.lockmoney}}</span>元</div>
                </div>
            </div>

            <el-tooltip content="商家正在申请提现的金额" placement="top">
                <div>
                    <i class="tip el-icon-info"></i>
                </div>
            </el-tooltip>
        </div>
        <div class="outbox box-shadow bgc">
            <div class="box">
                <div class="box-detail">
                    <div class="box-title">商家可提现金额</div>
                    <div class="box-data"><span class="data">{{item.validmoney}}</span>元</div>
                </div>
            </div>

            <el-tooltip content="商家所有活动还可提现的金额" placement="top">
                <div>
                    <i class="tip el-icon-info"></i>
                </div>
            </el-tooltip>
        </div>
    </div>
    <div class="filters bgc">
        <div class="add">
            <el-button v-if="permission.btnList.indexOf('A09')==-1" type="danger" @click="handleAdd">提现申请</el-button>
        </div>
        <div class="search">
            <el-select v-model="param.status" placeholder="请选择" @change="handleQuery">
                <el-option v-for="item in statusList" :key="item.code" :label="item.name" :value="item.code">{{item.name}}</el-option>
            </el-select>
        </div>
    </div>
    <div class="result-list btn-operate-list padding-20 bgc">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="innerid" label="申请编号" width="170px"></el-table-column>
            <el-table-column prop="datetime" label="申请时间" class-name="center" width="170px"></el-table-column>
            <el-table-column prop="cashtypetext" label="提现类型" class-name="center" width="150px"></el-table-column>
            <el-table-column prop="cashmoney" label="提现金额" class-name="center" width="150px">
                <template slot-scope="scope">￥{{scope.row.cashmoney}}</template>
            </el-table-column>
            <el-table-column prop="feemoney" label="手续费" class-name="center" width="150px">
                <template slot-scope="scope">￥{{scope.row.feemoney}}</template>
            </el-table-column>
            <el-table-column prop="cashaccountmoney" label="到账金额" class-name="center" width="150px">
                <template slot-scope="scope">￥{{scope.row.cashaccountmoney}}</template>
            </el-table-column>
            <el-table-column prop="status" label="状态" class-name="center" width="100px">
                <template slot-scope="scope">
                    <span :class="status(scope.row.status)">{{scope.row.statustext}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="authdesp" label="备注" class-name="right">
                <template slot-scope="scope">
                    <span >{{scope.row.authdesp? scope.row.authdesp :'--'}}</span>
                </template>
            </el-table-column>
        </el-table>
        <page :total="total" @getList="_getList" ref="page"></page>
    </div>
</div>
</template>

<script>
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
import {getCashInfoList, getStatisticsCashInfo} from 'api/nationalDistribution'
import {nationalDistribution} from 'api/enumCode'
export default {
    name: 'WithdrawalList',
    data() {
        return {
            activityList: [],
            title: '提现列表',
            tableData: [],
            total: 0,
            statusList: nationalDistribution.applyStatus,
            loading: false,
            item: {
                settlemoney: '', // 待提现金额
                lockmoney: '', // 提现中金额
                validmoney: '' // 可提现金额
            },
            selectPage: {
                page: 1,
                pageSize: 10,
                pageCount: 1
            }
        }
    },
    props: ['param', 'flag'],
    mounted() {
        this.power = this.permission.btnObj.A09 ? this.permission.btnObj.A09 : []
        this._getStatisticsCashInfo()
    },
    methods: {
        handleQuery() {
            this.$refs.page.handleSizeChange(1)
        },
        handleAdd() {
            // if (!this.param.eventinnerid) {
            //     this.$alert('请选择活动', '提示', {
            //         dangerouslyUseHTMLString: true
            //     })
            // } else
            if (this.item.settlemoney <= 0) {
                this.$alert('可提现金额不能小于0', '提示', {
                    dangerouslyUseHTMLString: true
                })
            } else {
                // this.$router.push({name: 'NDWithdrawalEdit', query: {id: this.param.eventinnerid}})
                this.$router.push({name: 'Withdrawal'})
            }
        },
        _getStatisticsCashInfo() {
            this.setLoading(true)
            getStatisticsCashInfo({
                data: {eventinnerid: this.param.eventinnerid},
                success: data => {
                    this.item = data.data
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getCashInfoList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setParams'
        ])
    },
    filters: {
        status: function (value) {
            return value
        }
    },
    watch: {},
    computed: {
        status () {
            return function(value) {
                for (let i = 0; i < nationalDistribution.status.length; i++) {
                    if (value === nationalDistribution.status[i].code) {
                        return nationalDistribution.status[i].cls
                    }
                }
                return value
            }
        },
        ...mapGetters([
            'page',
            'user',
            'permission',
            'params'
        ])
    },
    components: {
        Page
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.WithdrawalList {
    .title{
        @include flexBox(space-between);
        height: 60px;
        padding: 0 20px;
        .classes{
            margin-bottom: 0;
        }
    }
    .data-total{
        margin-top: 24px;
        @include flexBox(space-between);
        .outbox{
            padding: 30px;
            height: 100px;
            box-sizing: border-box;
            position: relative;
            flex-grow: 1;
            flex-basis: 200px;
            .box{}
            .el-tooltip{
                position: absolute;
                width: 14px;
                height: 14px;
                top: 10px;
                right: 10px;
            }
        }
        .outbox+.outbox{
            margin-left: 40px;
        }
    }
    .filters{
        margin-top: 24px;
        margin-bottom: 0;
        padding: 20px 20px 10px 20px;
    }
    .center{
        .cell{
            text-align: center;
        }
    }
    .right{
        .cell{
            text-align: right;
        }
    }
}
</style>
